<template>
  <div class="animated fadeIn serviceorders--serviceorders-list">
    <div v-if="isUnpublishedQboPage">
      <h6> Please select a WO to publish to Quickbooks. Note: A WO should be authorized before publishing to Quickbooks. </h6>
    </div>  
    <div class="d-flex justify-content-start align-items-end mb-2" v-if="isAccountPage">
      <b-form-group label="Status" class="mr-2">
        <b-form-select v-model="filterObj.statusId" @change="onSearch">
          <option :value="null">All</option>
          <option v-for="option in sortSelect(serviceOrdersStatusOptions)" :key="option.name" :value="option.id">
            {{option.name}}
          </option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Sales Order Number" class="mr-2">
        <b-form-input v-model="filterObj.poNumber" @input="onSearch" size="sm"/>
      </b-form-group>
      <b-form-group label="Purchase Order Number" class="mr-2">
        <b-form-input v-model="filterObj.poNumber" @input="onSearch" size="sm"/>
      </b-form-group>
      <b-form-group label="Company" class="mr-2">
        <b-form-input v-model="filterObj.companyName" @input="onSearch" size="sm"/>
      </b-form-group>
      <b-form-group label="Past Due" class="mr-2">
        <b-form-checkbox v-model="filterObj.pastDue" @input="onSearch" value="true" unchecked-value=""/>
      </b-form-group>
      <b-form-group label="Sales Rep" class="mr-2">
        <b-form-select v-model="filterObj.salesPersonUserId" @change="onSearch">
          <option :value="null">All</option>
          <option
            v-for="(selectRep, indexRep) in sortSelect(salesReps)"
            :key="indexRep"
            :value="selectRep.id"
          >{{ selectRep.name }}
          </option>
        </b-form-select>
      </b-form-group>
      <date-range-picker ref="dateRangePicker" :handleSearch="onSearch"></date-range-picker>
      <b-button class="mr-2" size="sm" @click="onClear">Clear filters</b-button>
      <div class="buttons-panel" v-if="checkClaim(CAN_POST_PAYMENT) && !isUnpublishedQboPage">
        <b-button size="sm" variant="primary" class="mr-2" @click="add()">
          <i class="fa fa-plus" aria-hidden="true"></i>
          Post Payment
        </b-button>
      </div>
      <div v-else-if="checkClaim(CAN_EDIT_POS) && isUnpublishedQboPage">
        <b-button size="sm" variant="primary" @click="onSaveToQbo" :disabled="isQboLoading || checkedRowItemIdsArr.length == 0">
          <i v-show="isQboLoading" class="fa fa-spinner fa-pulse fa-fw mr-2"></i> 
          <span v-if="isQboLoading">Publishing...</span>
          <span v-else>
            Publish {{ checkedRowItemIdsArr.length }} selected WO{{checkedRowItemIdsArr.length > 1 ? 's' : '' }} to Quickbooks
          </span>
        </b-button>
      </div>
    </div>
    <grid-component
      isResizable
      isReorderable
      isSortable
      :canEdit="checkClaim(CAN_EDIT_WORK_ORDER)"
      :canDelete="checkClaim(CAN_DELETE_WORK_ORDERS)"
      :gridId="gridId"
      :itemData="itemData"
      :fields="columnFields"
      :handleRowClick="onRowClick"
      :onEdit="pushToDetails"
      :onDelete="onDelete"
      :sortBy="gridInfo.sortBy"
      :sortOrder="gridInfo.sortOrder"
      :sortMethod="onSort"
      :checkBoxValues="checkedRowItemIdsArr"
      @checkedItem="checkedRowItemIdsArr=$event"
    />
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
  import { debounce, unionBy } from 'lodash';
  import { GRID_ID, CHECKBOX_GRID_COLUMN } from '@/shared/constants';
  import GridSettings from '@/shared/components/GridSettings';
  import GridComponent from '@/shared/components/GridComponent';
  import gridFields from '@/pages/ServiceOrders/fields';
  import DateRangePicker from '@/shared/components/DateRangePicker';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    components: {
      GridSettings,
      GridComponent,
      DateRangePicker,
    },
    props: {
      isAccountPage: {
        type: Boolean,
        default: false,
      }, isClear: {
        type: Boolean,
        default: false,
      }, filterPageName: {
        type: String,
        default: 'sharedSoPage',
      }, forPage: {
        type: String,
        default: '',
      },
      purchaseOrderId: {
        type: Number,
        default: 0,
      },
      isParentList: {
        type: Boolean,
        default: false,
      } ,
      serviceOrdersParentList: {
        type: Array,
        default: () => []
      },
      gridId: {
        type: String,
        default: GRID_ID.SERVICE_ORDERS 
      },
      isUnpublishedQboPage: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        fields: gridFields,
        selectedRowItemId: 0,
        serviceOrdersStatusOptions: [
          { id: 316, name: 'Pending' },
          { id: 317, name: 'Open' },
          { id: 318, name: 'Closed' },
        ],
        selectedServiceOrderRow: {},
        isQboLoading: false,
        checkedRowItemIdsArr: []
      };
    },
    computed: {
      ...mapState('salesReps', ['salesReps']),
      ...mapGetters('serviceOrders', [
        'serviceordersList',
        'pageInfo',
        'filters',
        'selectedItemId',
        'dateRange',
      ]),
      ...mapGetters('account', ['gridSettingsById']),
      ...mapGetters('shippingReceiving', ['woPageInfo']),
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      itemData() {
        let listing = this.isParentList ? this.serviceOrdersParentList : this.serviceordersList;

        if (listing == undefined || !listing.length) return [];
        return listing.map((serviceOrder) => ({
          ...serviceOrder,
          selected: serviceOrder.id === this.selectedRowItemId,
        }));
      },
      filterObj() {
        return this.filters[this.filterPageName] || {}
      },
      gridInfo() {
        return this.isParentList ? this.woPageInfo : this.pageInfo;
      },
      columnFields() {
        let columnFields = [ ...this.fields ];

        if (this.isUnpublishedQboPage) {
          columnFields.unshift(CHECKBOX_GRID_COLUMN);
        }
        return columnFields;
      }
    },
    methods: {
      ...mapActions('serviceOrders', ['getAll', 'sortGrid', 'getPage', 'remove', 'search', 'clearFilters','deleteServiceOrder', 'multiSaveToQuickbooks']),
      ...mapActions('account', ['saveGridSettings']),
      ...mapActions('salesReps', ['getSalesReps']),
      ...mapMutations('serviceOrders', ['setItem','setFilters','setLastOpenedId']),
      onSort($e) {
        if (this.isParentList) {
          this.$emit('onSort', $e);
        } else {
          this.sortGrid($e);
        }
        
      },
      onSearch: debounce(function(data = false) {
        if (this.isAccountPage) {
          if (typeof data === 'object') {
            Object.assign(this.filterObj, data);
          }
          this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
          // this.filterObj.hasBalance = this.isAccountPage;
        }
        this.search({'filters':this.filterObj,page:this.filterPageName});
      }, SEARCH_DEBOUNCE_TIME),
      onRowClick(row) {
        this.selectedRowItemId = row.dataItem.id;
        this.selectedServiceOrderRow = row.dataItem
        this.$emit('selectedServiceOrder', row.dataItem);
      },
      add() {
        this.$router.push({
          name: 'billpayments.add', params: {
            sourceId: 2,
            suggestion: { id: this.selectedServiceOrderRow.companyId, name: this.selectedServiceOrderRow.companyName },
            total: this.selectedServiceOrderRow.total,
          },
        });
      },
      async getServiceOrders() {
        if (this.isAccountPage) {
          this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
          // this.filterObj.hasBalance = this.isAccountPage;
          this.setFilters(this.filterObj);
        }
        if (this.purchaseOrderId) {
          this.filterObj.poNumber = this.purchaseOrderId;
          this.setFilters(this.filterObj);
        }
        await this.getAll({});
      },
      onClear(callSearch = true) {
        this.clearFilters();
        this.checkedRowItemIdsArr = [];
        Object.keys(this.filterObj).forEach(filterName => {
          this.filterObj[filterName] = null;
        });
        this.isUnpublishedQboPage ? this.filterObj.IsQboUnpublished = true : this.filterObj.hasBalance=true;
        // this.filterObj.hasBalance = this.isAccountPage;
        this.$refs.dateRangePicker.setDateRangeAll(); //Clear date range picker
        if (callSearch) {
          this.search({'filters':this.filterObj,page:this.filterPageName});
        }
      },
      pushToDetails(row) {
        this.setLastOpenedId(row.id);

        this.$router.push({
          name: 'serviceorders.edit',
          params: { id: row.id },
        });
      },
      async onDelete(serviceOrder) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete Work Order #${serviceOrder.id}?`});
        if (deleteConfirmed) {
          await this.deleteServiceOrder(serviceOrder.id);
          this.getAll({});
        }
      },
      async onSaveToQbo() {
        try {
          this.isQboLoading = true;
          const response = await this.multiSaveToQuickbooks(this.checkedRowItemIdsArr);
          this.isQboLoading = false;
          if (response.status == 200) {
            this.$snotify.success('Successfully published to quickbooks');
            this.checkedRowItemIdsArr = [];
            this.getAll({});
          }
          
        } catch(e) {
          this.isQboLoading = false;
        } 
      }
    },
    watch: {
      purchaseOrderId(newid){
        if(this.purchaseOrderId){
          this.getServiceOrders()
        } else {
          this.clearFilters();
          this.setItem({ resource:'serviceordersList', payload: [] });
        }
      }
    },
    mounted() {
      this.setItem({ resource:'filterPage', payload: this.filterPageName });
      if (this.isClear) {
        this.pageInfo.pageNumber = 1;
        this.onClear(false);
      } else {
        let goGetData = (this.isAccountPage || this.purchaseOrderId);
        if (goGetData) {
          this.getServiceOrders();
        }
        if (this.isAccountPage) this.getSalesReps();
      }
    },
  };
</script>

<style lang="scss">
  @import '@/assets/scss/_colors.scss';

  #serviceorders-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
  }

  #serviceorders-header-nav-txt {
    background-color: #fff;
    padding: 8px;
    font-size: 20px;
    margin: 0px;
  }


  .serviceorders {
    &--serviceorders-list {
      .tools > * {
        margin: 0 0 0 3px;
      }

      .b-pagination {
        justify-content: center;
      }

      .create-ultra-rfp {
        margin-top: 0.5em;
        margin-bottom: 1em;
      }

      table td {
        cursor: pointer;
      }

      .buttons-panel {
        text-align: right;
        margin-right: 30px;
        margin-top: 7px;

        .btn {
          margin-left: 5px;
        }

      }

      .clear-filter-button-container {
        margin-top: 12px;
        text-align: right;
      }
    }

    &--grid-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

  .highlight {
    background: $rowSelection !important;
  }

  .b-pagination {
    justify-content: center;
  }

  .tools > * {
    margin: 0 0 0 3px;
  }

  #KendoGrid .k-virtual-scrollable-wrap table {
    min-width: 800px;
  }
</style>
